// One Verify route allowlist helpers.
// Scoped to One Verify (practice-id paths); not used by calculator / labeling.
export class OneVerifyRouteHelper {
    /**
     * Normalize a request path for One Verify allowlist comparison.
     * Strips origin / query / trailing slash and replaces numeric practice ids.
     */
    static normalizeRoute(pathOrUrl: string): string {
        let path = pathOrUrl.split("?")[0]

        if (path.includes("://")) {
            try {
                path = new URL(path).pathname
            } catch {
                // Keep path as-is if URL parsing fails
            }
        }

        path = path.replace(/\/$/, "")
        path = path.replace(/\/practices\/\d+/, "/practices/:practiceId")

        return path
    }

    /**
     * Whether a request method/path is allowed against a One Verify route allowlist.
     * GET always passes; other methods must match a normalized route in `allowedRoutes` (default empty).
     */
    static isRouteAllowed(
        method: string,
        pathOrUrl: string,
        allowedRoutes: string[] = [],
    ): boolean {
        if (method.toUpperCase() === "GET") {
            return true
        }

        return allowedRoutes.includes(
            OneVerifyRouteHelper.normalizeRoute(pathOrUrl),
        )
    }
}
